// extracted by mini-css-extract-plugin
export var productImage = "_mn-0";